"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IOrgProfileUpdate = void 0;
const openapi_1 = require("../../../openapi");
const IFaq_1 = __importDefault(require("../../../shared/models/IFaq"));
const IWarehouseInfoUpdate_1 = require("./IWarehouseInfoUpdate");
class IOrgProfileUpdate {
    id;
    orgKey;
    extensivId;
    status;
    editStatus;
    name;
    website;
    foundedIn;
    joinedExtensivIn;
    logo;
    contact;
    salesforceContactId;
    salesforceAccountId;
    hubspotRowId;
    address;
    companySummary;
    description;
    faqs;
    warehouseInfo;
    expertise;
    lastUpdatedDate;
    sortOrder;
    preferredRegion;
    featured;
    defaultRecommendation;
    pagePath;
    capabilities;
}
__decorate([
    (0, openapi_1.Schema)({ type: 'string', format: 'uuid' })
], IOrgProfileUpdate.prototype, "id", void 0);
__decorate([
    (0, openapi_1.Schema)({ type: 'string', format: 'uuid' })
], IOrgProfileUpdate.prototype, "orgKey", void 0);
__decorate([
    (0, openapi_1.Schema)({ type: 'string' })
], IOrgProfileUpdate.prototype, "extensivId", void 0);
__decorate([
    (0, openapi_1.Schema)({ type: 'string' })
], IOrgProfileUpdate.prototype, "status", void 0);
__decorate([
    (0, openapi_1.Schema)({ type: 'string' })
], IOrgProfileUpdate.prototype, "editStatus", void 0);
__decorate([
    (0, openapi_1.Schema)({ type: 'string' })
], IOrgProfileUpdate.prototype, "name", void 0);
__decorate([
    (0, openapi_1.Schema)({ type: 'string' })
], IOrgProfileUpdate.prototype, "website", void 0);
__decorate([
    (0, openapi_1.Schema)({ type: 'number' })
], IOrgProfileUpdate.prototype, "foundedIn", void 0);
__decorate([
    (0, openapi_1.Schema)({ type: 'number' })
], IOrgProfileUpdate.prototype, "joinedExtensivIn", void 0);
__decorate([
    (0, openapi_1.Schema)({ type: 'string' })
], IOrgProfileUpdate.prototype, "logo", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'object' })
], IOrgProfileUpdate.prototype, "contact", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IOrgProfileUpdate.prototype, "salesforceContactId", void 0);
__decorate([
    (0, openapi_1.Schema)({ type: 'string' })
], IOrgProfileUpdate.prototype, "salesforceAccountId", void 0);
__decorate([
    (0, openapi_1.Schema)({ type: 'string' })
], IOrgProfileUpdate.prototype, "hubspotRowId", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'object' })
], IOrgProfileUpdate.prototype, "address", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IOrgProfileUpdate.prototype, "companySummary", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IOrgProfileUpdate.prototype, "description", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'array', items: (0, openapi_1.ref)(() => IFaq_1.default) })
], IOrgProfileUpdate.prototype, "faqs", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'array', items: (0, openapi_1.ref)(() => IWarehouseInfoUpdate_1.IWarehouseInfoUpdate) })
], IOrgProfileUpdate.prototype, "warehouseInfo", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'array', items: (0, openapi_1.ref)(() => String) })
], IOrgProfileUpdate.prototype, "expertise", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'number' })
], IOrgProfileUpdate.prototype, "lastUpdatedDate", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'number' })
], IOrgProfileUpdate.prototype, "sortOrder", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IOrgProfileUpdate.prototype, "preferredRegion", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'boolean' })
], IOrgProfileUpdate.prototype, "featured", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'boolean' })
], IOrgProfileUpdate.prototype, "defaultRecommendation", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IOrgProfileUpdate.prototype, "pagePath", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'array', items: { type: 'string' } })
], IOrgProfileUpdate.prototype, "capabilities", void 0);
exports.IOrgProfileUpdate = IOrgProfileUpdate;
